import clsx from "clsx";
import { FunctionComponent } from "react";

import * as styles from "@ui/components/article/ShareButtons/components/ShareButtonsSharePopover/ShareButtonsSharePopover.css";
import * as shareButtonsStyles from "@ui/components/article/ShareButtons/ShareButtons.css";
import FacebookIcon from "@ui/components/icon/social/FacebookIcon";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  onPopoverClose: () => void;
}

/**
 * Facebook share button component for the share popover
 */
const ShareButtonsFacebookPopover: FunctionComponent<Props> = ({
  url,
  onPopoverClose,
}) => {
  const analytics = useAnalytics();

  const handleFacebookShare = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "facebook" },
    });

    const encodedUrl = encodeURIComponent(url);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    window.open(
      facebookUrl,
      "share_facebook",
      "width=658, height=354, scrollbars=no",
    );
    onPopoverClose();
  };

  return (
    <button
      onClick={handleFacebookShare}
      className={styles.shareOption}
      aria-label="Share on Facebook"
    >
      <span
        className={clsx(
          shareButtonsStyles.button.standard,
          styles.shareIconContainer,
        )}
      >
        <FacebookIcon className={styles.shareIcon} />
      </span>
      <span className={styles.shareLabel}>Facebook</span>
    </button>
  );
};

export default ShareButtonsFacebookPopover;
